import cx from 'classnames';
import { useMemo, useRef } from 'react';
import { ClearButtonIcon } from '../../../icons/clear-button-icon';
import { SearchButtonIcon } from '../../../icons/search-button-icon';
import { useFilterPanelContext } from '../../context/FilterPanelContext';
import style from '../../FilterPanel.module.scss';
import { areFiltersChecked } from '../../helpers/areFiltersChecked';
import SaveFilterPresetButton from './components/SaveFilterPresetButton/SaveFilterPresetButton';

const PrimaryButtonsLine = () => {
  const {
    fields,
    setValues,
    showFilters,
    setShowFilters,
    activePresetId,
    setActivePresetId,
    onFilterToggle,
    onSearch,
    values,
  } = useFilterPanelContext();

  const handleClearFields = () => {
    setValues(
      fields.reduce(
        (acc, f) => ({
          ...acc,
          [f.key]: f.type === 'dateRange' ? [undefined, undefined] : undefined,
        }),
        {}
      )
    );
    setActivePresetId(undefined);
  };

  return (
    <div className={style.leftButtons}>
      <button
        className={cx(style.filterBtn, !showFilters && style.closedFilterBtn)}
        onClick={() => {
          const newState = !showFilters;
          setShowFilters(newState);
          if (onFilterToggle) {
            onFilterToggle(newState);
          }
        }}
      >
        Фильтр
      </button>
      {showFilters && (
        <>
          <SaveFilterPresetButton />
          <button
            className={style.iconButton}
            onClick={() => handleClearFields()}
            title={'Очистить'}
          >
            <ClearButtonIcon />
          </button>
          <button
            className={cx(
              style.iconButton,
              areFiltersChecked(values) && style.filterSearchButton
            )}
            onClick={() => onSearch && onSearch(undefined)}
            title="Поиск"
          >
            <SearchButtonIcon />
          </button>
        </>
      )}
    </div>
  );
};

export default PrimaryButtonsLine;
